import { mergeAttributes, Node } from "@tiptap/core"
import * as z from "zod"
import { CARD_COLORS, SECTION_COLOR_MAP } from "../../util/colors"
import { toTiptapAttributes } from "../../util/render-data"

export const CardTitleAttrsSchema = z.object({
  color: z.enum(CARD_COLORS).default("yellow"),
})

export type ExtensionCardTitleAttrs = z.infer<typeof CardTitleAttrsSchema>

export const CardTitleContentExtension = Node.create({
  name: "cardTitle",
  content: "text*",
  marks: "",

  // Before heading, so parseHTML gets to our rendered H2's first.
  priority: 200,

  addAttributes: () => toTiptapAttributes(CardTitleAttrsSchema),

  renderHTML({ node, HTMLAttributes }) {
    const attrs = node.attrs as ExtensionCardTitleAttrs
    return [
      "h2",
      mergeAttributes(HTMLAttributes, {
        "data-content-type": "cardTitle",
        // Give it a color style for pasting into other programs.
        style: `color: ${SECTION_COLOR_MAP[attrs.color]};`,
      }),
      0,
    ]
  },

  parseHTML() {
    return [
      {
        tag: 'h2[data-content-type="cardTitle"]',
      },
    ]
  },

  // Markdown parse/render happens at the card or CardStack level instead of here.
})
